"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var semantic_ui_react_1 = require("semantic-ui-react");

var component_1 = require("../component");

var data_1 = require("../data");

var helper_1 = require("../helper");

exports.initialVizPanelState = {
  currentDataDir: '',
  data: new Object()
};

var VizPanelContainer =
/** @class */
function (_super) {
  __extends(VizPanelContainer, _super);

  function VizPanelContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.state = exports.initialVizPanelState;

    _this.renderFileUploadForm = function () {
      return React.createElement(semantic_ui_react_1.Label, {
        as: "label",
        basic: true,
        htmlFor: 'upload'
      }, React.createElement(semantic_ui_react_1.Button, {
        icon: 'upload',
        label: {
          basic: true,
          content: 'Upload'
        },
        labelPosition: 'right'
      }), React.createElement("input", {
        id: 'upload',
        onChange: _this.onDataUpload,
        hidden: true,
        type: 'file',
        multiple: true,
        required: true
      }));
    };

    _this.onDataUpload = function (e) {
      return __awaiter(_this, void 0, void 0, function () {
        var fileList, files, pdbIndex, mappingIndex_1, couplingIndex, pdbData, couplingResult, mappingResult, data;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              fileList = e.target.files;
              if (!fileList) return [3
              /*break*/
              , 5];
              files = Array.from(fileList);
              pdbIndex = files.findIndex(function (file) {
                return file.name.endsWith('.pdb');
              });
              mappingIndex_1 = files.findIndex(function (file) {
                return file.name.localeCompare('residue_mapping.csv') === 0;
              });
              couplingIndex = files.findIndex(function (file, index) {
                return file.name.endsWith('.csv') && index !== mappingIndex_1;
              });
              if (!(pdbIndex === -1 || mappingIndex_1 === -1 || couplingIndex === -1)) return [3
              /*break*/
              , 1];
              alert('Incorrect files uploaded! Please upload a file named residue_mapping.csv as well as a .pdb and .csv file!');
              return [3
              /*break*/
              , 5];

            case 1:
              return [4
              /*yield*/
              , data_1.ChellPDB.createPDB(files[pdbIndex])];

            case 2:
              pdbData = _a.sent();
              return [4
              /*yield*/
              , helper_1.readFileAsText(files[couplingIndex])];

            case 3:
              couplingResult = _a.sent();
              return [4
              /*yield*/
              , helper_1.readFileAsText(files[mappingIndex_1])];

            case 4:
              mappingResult = _a.sent();
              data = {
                couplingScores: helper_1.getCouplingScoresData(couplingResult, helper_1.generateResidueMapping(mappingResult)),
                pdbData: pdbData,
                secondaryStructures: []
              };
              this.setState({
                data: __assign({}, this.state.data, {
                  'Contact Map': data,
                  NGL: pdbData.nglStructure
                })
              });
              _a.label = 5;

            case 5:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    _this.onDataDirChange = function (event, data) {
      _this.setState({
        currentDataDir: data.value
      });
    };

    _this.state = __assign({}, _this.state, {
      currentDataDir: props.dataDirs[0]
    });
    return _this;
  }

  VizPanelContainer.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e_1, _a, results, _b, _c, viz, _d, _e, e_1_1;

      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            results = {};
            _f.label = 1;

          case 1:
            _f.trys.push([1, 6, 7, 8]);

            _b = __values(this.props.supportedVisualizations), _c = _b.next();
            _f.label = 2;

          case 2:
            if (!!_c.done) return [3
            /*break*/
            , 5];
            viz = _c.value;
            _d = results;
            _e = viz;
            return [4
            /*yield*/
            , helper_1.fetchAppropriateData(viz, this.state.currentDataDir)];

          case 3:
            _d[_e] = _f.sent();
            _f.label = 4;

          case 4:
            _c = _b.next();
            return [3
            /*break*/
            , 2];

          case 5:
            return [3
            /*break*/
            , 8];

          case 6:
            e_1_1 = _f.sent();
            e_1 = {
              error: e_1_1
            };
            return [3
            /*break*/
            , 8];

          case 7:
            try {
              if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
              if (e_1) throw e_1.error;
            }

            return [7
            /*endfinally*/
            ];

          case 8:
            this.setState({
              data: __assign({}, results)
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  VizPanelContainer.prototype.componentDidUpdate = function (prevProps, prevState) {
    return __awaiter(this, void 0, void 0, function () {
      var e_2, _a, results, _b, _c, viz, _d, _e, e_2_1;

      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            if (!(prevState.currentDataDir !== this.state.currentDataDir)) return [3
            /*break*/
            , 9];
            results = {};
            _f.label = 1;

          case 1:
            _f.trys.push([1, 6, 7, 8]);

            _b = __values(this.props.supportedVisualizations), _c = _b.next();
            _f.label = 2;

          case 2:
            if (!!_c.done) return [3
            /*break*/
            , 5];
            viz = _c.value;
            _d = results;
            _e = viz;
            return [4
            /*yield*/
            , helper_1.fetchAppropriateData(viz, this.state.currentDataDir)];

          case 3:
            _d[_e] = _f.sent();
            _f.label = 4;

          case 4:
            _c = _b.next();
            return [3
            /*break*/
            , 2];

          case 5:
            return [3
            /*break*/
            , 8];

          case 6:
            e_2_1 = _f.sent();
            e_2 = {
              error: e_2_1
            };
            return [3
            /*break*/
            , 8];

          case 7:
            try {
              if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
              if (e_2) throw e_2.error;
            }

            return [7
            /*endfinally*/
            ];

          case 8:
            this.setState({
              data: __assign({}, results)
            });
            _f.label = 9;

          case 9:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  VizPanelContainer.prototype.render = function () {
    var allowUploads = this.props.allowUploads;
    return React.createElement(semantic_ui_react_1.Grid, {
      className: 'VizPanelContainer',
      columns: this.props.numPanels,
      centered: true,
      relaxed: true
    }, React.createElement(semantic_ui_react_1.GridRow, {
      columns: 1,
      centered: true
    }, React.createElement(semantic_ui_react_1.Dropdown, {
      className: 'viz-panel-container-dropdown',
      onChange: this.onDataDirChange,
      options: __spread(this.props.dataDirs.map(function (dir) {
        return {
          key: dir,
          text: dir,
          value: dir
        };
      })),
      placeholder: this.props.dataDirs[0],
      search: true
    })), this.renderPanels(this.props.numPanels, this.state.data, this.props.initialVisualizations).map(function (panel, index) {
      return React.createElement(semantic_ui_react_1.GridColumn, {
        key: index
      }, panel);
    }), allowUploads && this.renderFileUploadForm());
  };

  VizPanelContainer.prototype.renderPanels = function (numPanels, data, initialVisualizations) {
    var result = [];

    for (var i = 0; i < numPanels; ++i) {
      result.push(React.createElement(component_1.VizSelectorPanel, {
        data: data,
        initialViz: initialVisualizations[i],
        supportedVisualizations: this.props.supportedVisualizations
      }));
    }

    return result;
  };

  VizPanelContainer.defaultProps = {
    allowUploads: true,
    initialVisualizations: [],

    /** Number of panels to be controlled by this container. Currently limited to 4. */
    numPanels: 1
  };
  return VizPanelContainer;
}(React.Component);

exports.VizPanelContainer = VizPanelContainer;